export const Environment = {
  discovery: 'https://tv-api.dev.nebula.androme.com/api/v1/bootstrap/discover',
  system: 'SMARTTV_TIZEN',
  Oauth: {
    clientId: 'androme.tv-smarttv-tizen-1',
    redirectUri: 'http://localhost:4200',
    uri: 'https://tv-api.dev.nebula.androme.com/api/oauth/v1/auth/authorize',
    secret: '8erFq8ftzM7fesug38Po',
  },
  Castlabs: {
    // use web license key so we can watch video on dev websites
    licenseKey:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJ1cmxzIjpbImh0dHBzOi8vdHYuZGV2Lm5lYnVsYS5hbmRyb21lLmNvbSJdLCJ0eXBlIjoiV2ViIiwia2lkIjozMTAxLCJpbHYiOmZhbHNlfQ.H8ByvxuVDc2SX1eOoVlBSZSDBPXhYjQoQ87NX4VnvN6-fzJ-wP6KpV8zshtarsZc28I_AFrue_I9Nvh3fh9jdd8LsNSkRBiDpVpcQ1X5U5QymKjwD6bh42RqsBI-dv2qcHNqB_wpbm1lLvsoK6qX9Gq00XSd-baqC8es1wSE505bY3XRcAAau-PiS3RX8LquwOq3kERqjdt0U8kIsxB-juHi1YlNihIL3bPak7LBfnF2Rq5bcrsecb5yfMI0UPUtVrPJM8JMxNOBIXKcobUYCP4ebiqdKTT5grIIgdwEyh6XexGCJDO6HGSME2mYStX7VKcuiMgl-8m5CDPdxE6Yzw',
    drmMerchant: 'vpmedia_androme',
    drmEnvironment: 'DRMtoday_STAGING',
    drmStaging: true,
    defaultDrmProvider: 'PLAYREADY',
  },
  atv_ott_rights: ['LINEAR', 'NPVR'],
  atv_replay_ott_rights: ['REPLAY'],
};
